import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5755129f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white py-6" }
const _hoisted_2 = { class: "md:flex md:items-center md:justify-between sm:px-6 md:px-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 min-w-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate" }, " Realtime Dashboard ")
], -1))
const _hoisted_4 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 justify-center" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row justify-start items-center gap-y-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-gray-600 w-4 h-full mx-2 absolute pointer-events-none",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" })
], -1))
const _hoisted_8 = ["value", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "analytics bg-white border-t border-gray-200 px-4 md:px-7",
  ref: "container",
  style: {"position":"relative"}
}
const _hoisted_10 = { class: "text-2xl font-bold leading-7 text-gray-800 mt-7 mb-4 sm:truncate" }
const _hoisted_11 = { class: "grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4" }
const _hoisted_12 = { class: "card green" }
const _hoisted_13 = { class: "key" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "ml-1" }
const _hoisted_16 = { class: "value-2" }
const _hoisted_17 = { class: "ml-1" }
const _hoisted_18 = { class: "card red" }
const _hoisted_19 = { class: "key" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "ml-1" }
const _hoisted_22 = { class: "value-2" }
const _hoisted_23 = { class: "ml-1" }
const _hoisted_24 = { class: "card gray" }
const _hoisted_25 = { class: "key" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ml-1" }, "%", -1))
const _hoisted_28 = { class: "value-2" }
const _hoisted_29 = { class: "ml-1" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Estimated Win/Loss", -1))
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "ml-1" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Game Played Today", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ml-1" }, "Rounds", -1))
const _hoisted_38 = { class: "card" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "New Users Today", -1))
const _hoisted_40 = { class: "value" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ml-1" }, "Users", -1))
const _hoisted_42 = { class: "md:w50 sm:w-auto mt-7" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Suspect List", -1))
const _hoisted_44 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_45 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Username"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, "Reason"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    })
  ])
], -1))
const _hoisted_47 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_48 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_49 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-4" }
const _hoisted_50 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500" }
const _hoisted_51 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right w-48 text-gray-500" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Safe")
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center pt-3 pb-3"
}, "No suspected users", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  colspan: "4",
  class: "text-center pt-3 pb-3 pr-4 text-right font-bold text-blue-400"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" View All")
const _hoisted_60 = { class: "grid md:grid-cols-3 gap-4 mt-7" }
const _hoisted_61 = { class: "md:w50 sm:w-auto" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Top Deposit", -1))
const _hoisted_63 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_64 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Username"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Amount")
  ])
], -1))
const _hoisted_66 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_67 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_68 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500" }
const _hoisted_69 = { class: "md:w50 sm:w-auto" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Top Withdraw", -1))
const _hoisted_71 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_72 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Username"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Amount")
  ])
], -1))
const _hoisted_74 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_75 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_76 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500" }
const _hoisted_77 = { class: "md:w50 sm:w-auto" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Top Ratio", -1))
const _hoisted_79 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_80 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Username"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Ratio")
  ])
], -1))
const _hoisted_82 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_83 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_84 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500" }
const _hoisted_85 = { class: "md:w50 sm:w-auto mt-7 pb-16" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, [
    /*#__PURE__*/_createTextVNode("Provider Rank "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "(ยอดบวกหมายถึงเสียเงินให้ผู้เล่น)")
  ])
], -1))
const _hoisted_87 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_88 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Provider Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Amount")
  ])
], -1))
const _hoisted_90 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_91 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_92 = { class: "bg-gray-50 text-gray-900" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left py-4 pl-4 pr-3 font-bold" }, "Estimated Win/Loss", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              class: "",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                  mode: "date",
                  masks: { input: 'DD MMMM YYYY' }
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("input", {
                        class: "flex-grow rw pl-8 pr-2 py-1 bg-gray-100 border rounded w-59 text-gray-900",
                        value: inputValue,
                        onClick: togglePopover
                      }, null, 8, _hoisted_8),
                      _createElementVNode("button", {
                        class: "px-3 py-2 ml-2 bg-blue-500 text-xs text-white font-semibold rounded-md",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
                      }, " APPLY ")
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("messages.dashboard.incomeSummary")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("messages.dashboard.totalDeposit")), 1),
              _createElementVNode("span", _hoisted_14, [
                _createTextVNode(_toDisplayString(!_ctx.data?.summary?.deposit_count ? 0 : (+_ctx.data.summary.deposit_count).toLocaleString("us", {
            maximumFractionDigits: 2
          })) + " ", 1),
                _createElementVNode("small", _hoisted_15, _toDisplayString(_ctx.$t("messages.dashboard.Transactions")), 1)
              ]),
              _createElementVNode("span", _hoisted_16, [
                _createTextVNode(_toDisplayString(!_ctx.data?.summary?.deposit_amount ? 0 : (+_ctx.data.summary.deposit_amount / 100).toLocaleString("us", {
            maximumFractionDigits: 2
          })) + " ", 1),
                _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("messages.dashboard.totalWithdraw")), 1),
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(!_ctx.data?.summary?.withdraw_count ? 0 : (+_ctx.data.summary.withdraw_count).toLocaleString("us", {
            maximumFractionDigits: 2
          })) + " ", 1),
                _createElementVNode("small", _hoisted_21, _toDisplayString(_ctx.$t("messages.dashboard.Transactions")), 1)
              ]),
              _createElementVNode("span", _hoisted_22, [
                _createTextVNode(_toDisplayString(!_ctx.data?.summary?.withdraw_amount ? 0 : (+_ctx.data.summary.withdraw_amount / 100).toLocaleString("us", {
            maximumFractionDigits: 2
          })) + " ", 1),
                _createElementVNode("small", _hoisted_23, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("messages.dashboard.estimateProfit")), 1),
              _createElementVNode("span", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.data?.summary?.deposit_amount ? (((+_ctx.data.summary.deposit_amount - (!_ctx.data?.summary?.withdraw_amount ? 0 :
            +_ctx.data.summary.withdraw_amount)) * 100) / +_ctx.data.summary.deposit_amount).toLocaleString("us", {
              maximumFractionDigits: 2
            }) : 0) + " ", 1),
                _hoisted_27
              ]),
              _createElementVNode("span", _hoisted_28, [
                _createTextVNode(_toDisplayString((((!_ctx.data?.summary?.deposit_amount ? 0 : +_ctx.data.summary.deposit_amount) - (!_ctx.data?.summary?.withdraw_amount ?
            0
            : +_ctx.data.summary.withdraw_amount)) / 100).toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
                _createElementVNode("small", _hoisted_29, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, [
                _createTextVNode(_toDisplayString((((!_ctx.data?.summary?.bet_amount ? 0 : +_ctx.data.summary.bet_amount) - ((+_ctx.data.summary.bonus_n_jackpot || 0) +
            (!_ctx.data.summary.settle_amount ? 0 : +_ctx.data.summary.settle_amount))) / 100).toLocaleString("us", {
              maximumFractionDigits: 2
            })) + " ", 1),
                _createElementVNode("small", _hoisted_33, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, [
                _createTextVNode(_toDisplayString((+_ctx.data.summary.game_round || 0).toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
                _hoisted_37
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, [
                _createTextVNode(_toDisplayString((+_ctx.data.summary.new_user || 0).toLocaleString("us", { maximumFractionDigits: 0 })) + " ", 1),
                _hoisted_41
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("table", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("tbody", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.suspects, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.name
                    }, [
                      _createElementVNode("td", _hoisted_48, [
                        _createVNode(_component_router_link, {
                          to: { name: 'Player Wallet Transaction', params: { id: user.id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(user.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(user.reason), 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString((+user.amount /
                100).toLocaleString("us", { maximumFractionDigits: 2 })), 1),
                      _createElementVNode("td", _hoisted_51, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeFromSuspect(user, index)),
                          class: "mr-2 inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check-circle'] }),
                          _hoisted_53
                        ], 8, _hoisted_52)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  (_ctx.data.suspects.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_54, _hoisted_56))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                        _createElementVNode("td", _hoisted_58, [
                          _createVNode(_component_router_link, {
                            to: { name: 'Realtime Dashboard Suspect Users', params: { date: _ctx.date }}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_59
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("table", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("tbody", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.deposit_rank, (user) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.name
                      }, [
                        _createElementVNode("td", _hoisted_67, [
                          _createVNode(_component_router_link, {
                            to: { name: 'Player Wallet Transaction', params: { id: user.id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", _hoisted_68, _toDisplayString((+user.value /
                  100).toLocaleString("us", { maximumFractionDigits: 2 })), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("table", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("tbody", _hoisted_74, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.withdraw_rank, (user) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.name
                      }, [
                        _createElementVNode("td", _hoisted_75, [
                          _createVNode(_component_router_link, {
                            to: { name: 'Player Wallet Transaction', params: { id: user.id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", _hoisted_76, _toDisplayString((+user.value /
                  100).toLocaleString("us", { maximumFractionDigits: 2 })), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("table", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("tbody", _hoisted_82, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.ratio_rank, (user) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.name
                      }, [
                        _createElementVNode("td", _hoisted_83, [
                          _createVNode(_component_router_link, {
                            to: { name: 'Player Wallet Transaction', params: { id: user.id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", _hoisted_84, _toDisplayString((+user.value).toLocaleString("us", { maximumFractionDigits: 2 })), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("table", _hoisted_88, [
                _hoisted_89,
                _createElementVNode("tbody", _hoisted_90, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.provider_rank, (provider) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: provider.name
                    }, [
                      _createElementVNode("td", _hoisted_91, [
                        _createVNode(_component_router_link, {
                          to: { name: 'Realtime Dashboard Provider User', params: { providerId: provider.id, date: _ctx.date } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(provider.id), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", {
                        class: _normalizeClass(["whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500", +provider.value > 0 ? 'text-red-600' : 'text-green-600'])
                      }, _toDisplayString((+provider.value /
                  100).toLocaleString("us", { maximumFractionDigits: 2 })), 3)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", _hoisted_92, [
                  _createElementVNode("tr", null, [
                    _hoisted_93,
                    _createElementVNode("td", {
                      class: _normalizeClass(["text-right py-4 pl-4 pr-3 font-bold", _ctx.data.provider_rank.reduce((a, b) => +b.value + a, 0) > 0 ? 'text-red-600' : 'text-green-600'])
                    }, _toDisplayString((_ctx.data.provider_rank.reduce((a, b) => +b.value + a, 0) / 100).toLocaleString("us", {
                  maximumFractionDigits: 2
                })), 3)
                  ])
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}